import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgPark(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5012 19.0883C8.73665 18.9712 6.97589 18.6474 5.22003 18.1202C3.35799 17.6513 2 15.9758 2 14.043C2 12.6987 2.63515 11.5026 3.61672 10.7392C2.58003 9.11122 2.82501 6.91046 4.19114 5.54345C5.15319 4.58078 6.56112 4.14338 7.89715 4.38592C8.26931 2.44759 9.96977 1 12 1C14.0306 1 15.7308 2.44823 16.1037 4.3867C17.4377 4.13935 18.8491 4.58307 19.8089 5.54345C21.1763 6.91177 21.4185 9.1113 20.3832 10.7409C21.3657 11.5033 22 12.6996 22 14.043C22 15.9608 20.7097 17.5855 18.9333 18.0751C17.1602 18.6218 15.3297 18.9666 13.499 19.0882L13.499 21.5017C13.499 22.3301 12.8279 23.0016 12 23.0016C11.1721 23.0016 10.501 22.33 10.5011 21.5016L10.5012 19.0883Z", fill: "currentColor" })));
}
export default SvgPark;
